export default "__VITE_ASSET__DZp13coI__"